import { render, staticRenderFns } from "./blogRedirect.vue?vue&type=template&id=5f28ff03&scoped=true&"
import script from "./blogRedirect.vue?vue&type=script&lang=js&"
export * from "./blogRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28ff03",
  null
  
)

export default component.exports